<template>
  <div class="tw-mt-4 tw-flex tw-flex-row tw-space-x-4 tw-rounded-lg tw-bg-gray-100 tw-p-6 tw-text-sm">
    <div class="tw-flex">
      <div
        class="tw-relative tw-inline-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full"
        :style="`background-color: ${$page.props.customisation.secondary_background}`"
      >
        <font-awesome-icon
          class="tw-pt-0.5"
          :style="{ color: $page.props.customisation.secondary_text }"
          :icon="['fa', 'message']"
        />
      </div>
    </div>
    <div class="tw-flex tw-flex-col">
      <span class="tw-text-base tw-font-bold tw-text-gray-800">{{ $page.props.business.name }}</span>
      <span class="tw-text-gray-400">{{ response.submitted_on }}</span>
      <div class="tw-whitespace-pre-line tw-py-2">
        <p v-if="showEllipsis" v-snip="{ lines: lines, onSnipped: onSnipped, mode: 'js' }">
          {{ response.message }}
        </p>
        <p v-else>
          {{ response.message }}
        </p>
      </div>
      <a
        href
        class="tw-w-fit tw-underline"
        :style="{ color: $page.props.customisation.secondary_background }"
        v-if="showEllipsis && hasEllipsis"
        @click.prevent="readMore()"
      >
        Read more
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  response: Object,
});

let hasEllipsis = ref(true);
let showEllipsis = ref(true);

const lines = 4;

const onSnipped = newState => {
  hasEllipsis.value = newState.hasEllipsis;
};

const readMore = () => {
  showEllipsis.value = false;
};
</script>
